import '@/plugins/vue-composition-api'
import '@/styles/fonts.scss'
import '@/styles/styles.scss'
import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import i18n from "@/i18n";
import router from "@/router";
import store from "@/store";
import api from "@/api";
// mixins
import TokenMixin from '@/mixins/TokenMixin'
import UtilsMixin from '@/mixins/UtilsMixin.vue'
import VimeoMixin from '@/mixins/VimeoMixin.vue'
// components
import PageHeaderSlot from './components/PageHeaderSlot.vue'
import FormButton from './components/layout/FormButton.vue'
import VueSignaturePad from 'vue-signature-pad';
// prototype
import Fetcher from '@/prototype/Fetcher'
import Formatter from '@/prototype/Formatter'
import Validator from '@/prototype/Validator'
import CommonFn from '@/prototype/CommonFn'

import axios from 'axios'

import Validate from "@/prototype/src/validate";

Vue.config.productionTip = false

let config = {};
axios.get(`${window.location.origin}/config.json?timestamp=${new Date().getTime()}`).then((response) => {
  if (response && response.status === 200) {
    if (response.headers['content-type'] !== 'application/json' || !response.data || ((response.data['VUE_APP_RUN_MODE'] === undefined || response.data['VUE_APP_RUN_MODE'] === null || response.data['VUE_APP_RUN_MODE'] === ''))) {
      throw null;
    }

    config = response.data;
  } else {
    throw response;
  }
}).catch(() => {
  if (process.env) {
    config = process.env;
  }
}).finally(() => {
  const isAppMode = (modes = []) => {
    if (config && config.VUE_APP_RUN_MODE) {
      return Validate.isAppMode(config.VUE_APP_RUN_MODE, modes);
    }

    return false;
  }

  if (isAppMode(['DEV'])) {
    console.log('************************** Config **************************', config);
  }

  Vue.use(api, { config })
  Vue.use(CommonFn, { config })
  Vue.use(Validator, { config })
  Vue.use(Formatter, { config })
  Vue.use(Fetcher, { config })
  Vue.use(VueSignaturePad);
  Vue.mixin(TokenMixin)
  Vue.mixin(UtilsMixin)
  Vue.mixin(VimeoMixin)

  Vue.component('PageHeaderSlot', PageHeaderSlot)
  Vue.component('FormButton', FormButton)
  Vue.prototype.$appMode = config.VUE_APP_RUN_MODE;
  Vue.prototype.$mediaPath = `${config.VUE_APP_MEDIA_DOMAIN}/media/`;
  Vue.prototype.$reportPath = `${config.VUE_APP_MEDIA_DOMAIN}/report/`;

  Vue.prototype.$config = config;


  i18n.init(config).then(async (oI18n) => {
    // **************** 會員等級
    let memberOptions = [
      { value: 'normal', text: oI18n.t('memberLevelOption.normal') },
      { value: 'vip', text: oI18n.t('memberLevelOption.vip') },
    ];
    if (isAppMode(['T27'])) {
      memberOptions = [
        { value: 'team_member', text: oI18n.t('memberLevelOption.team_member') },
        { value: 'team_head', text: oI18n.t('memberLevelOption.team_head') },
      ];
    }
    Vue.prototype.$memberOptions = memberOptions;

    // **************** 性別
    const genderOptions = [
      { value: 'M', text: oI18n.t('genderOption.M') },
      { value: 'F', text: oI18n.t('genderOption.F') },
    ];
    Vue.prototype.$genderOptions = genderOptions;

    // **************** 收生來源
    let sourceValues = ['whatsapp', 'instagram', 'facebook', 'rednote', 'referral', 'walk_in', 'wechat']
    if (isAppMode(['T40'])) {
      sourceValues.push('organization')
    } else if (isAppMode(['T49'])) {
      sourceValues = [...sourceValues, 'roadshow', 'others']
    } else if (isAppMode(['T50'])) {
      sourceValues = [
        ...sourceValues,
        'swimmer_recommend',
        'friend_recommend',
        'internet_recommend',
        'community_promotions',
        'coach_recommend',
      ]
    }
    Vue.prototype.$sourceOptions = sourceValues.map(value => {
      return { value: value, text: oI18n.t(`admissionSourceOptions.${value}`) }
    })

    // **************** 訂單類別
    Vue.filter('formatOrderType', function (value) {
      if (!value) return '';
      const statuses = ['course', 'product', 'package', 'custom', 'online_course', 'month_pass', 'skip'];
      if (statuses.includes(value)) {
        return oI18n.t(`orderTypeOption.${value}`);
      }
      return value;
    })

    // **************** 訂單狀態
    Vue.filter('formatOrderStatus', function (value) {
      if (!value) return '';
      const statuses = ['pending', 'paid', 'expired', 'null', 'processing', 'debit', 'void', 'not_issued'];
      if (statuses.includes(value)) {
        return oI18n.t(`orderStatusOption.${value}`);
      }
      return value;
    })

    // **************** 出席狀態
    Vue.filter('formatAttendanceStatus', function (value) {
      if (!value) return '';
      const statuses = ['pending', 'attend', 'absent', 'skip', 'reschedule', 'drop', 'swap', 'await'];
      if (statuses.includes(value)) {
        return oI18n.t(`attendanceStatus.${value}`);
      }
      return value;
    })

    // **************** 選擇薪酬計算法
    let salaryTypeOptions = [
      { value: 'level', text: oI18n.t('salaryMethodOptions.level') },
      { value: 'hour', text: oI18n.t('salaryMethodOptions.hour') },
      { value: 'percentage', text: oI18n.t('salaryMethodOptions.percentage') }
    ];
    if (isAppMode(['T16'])) {
      salaryTypeOptions = [
        { value: 'hour', text: oI18n.t('salaryMethodOptions.hour') },
        { value: 'percentage', text: oI18n.t('salaryMethodOptions.percentage') }
      ];
    }
    Vue.prototype.$salaryTypeOptions = salaryTypeOptions;

    let salaryMethodOptions = [
      { value: 'by_lesson', text: oI18n.t('salaryMethodOptions.by_lesson') },
      { value: 'by_student_num', text: oI18n.t('salaryMethodOptions.by_student_num') }
    ];
    Vue.prototype.$salaryMethodOptions = salaryMethodOptions;

    // **************** 薪酬等級
    const levels = 'abcdefghijklmnopqrstuvwxyz';
    let salaryLevelCount = 5;
    if (isAppMode(['T36'])) {
      salaryLevelCount = 20;
    }
    const salaryLevelOptions = [];
    for (let i = 0; i < salaryLevelCount; i++) {
      const key = levels.charAt(i);
      let name = oI18n.t(`salaryLevelName`, { level: key.toUpperCase() });
      if (isAppMode(['T17'])) {
        name = oI18n.t(`salaryLevelNameT17.${key}`)
      }
      salaryLevelOptions.push({ value: key, text: name })
    }
    Vue.prototype.$salaryLevelOptions = salaryLevelOptions

    // **************** 科目
    const subjects = ['chinese', 'english', 'mathematics', 'general_studies', 'economy', 'biology', 'chemistry', 'physic', 'citizenship_social_development', 'geography', 'history', 'chinese_history', 'others'];
    const subjectOptions = subjects.map(key => {
      return { value: key, text: oI18n.t(`subjectOption.${key}`) };
    });
    Vue.prototype.$subjectOptions = subjectOptions;

    // **************** 付款方式
    let paymentMethods = ['cash', 'fps', 'bank_transfer', 'payme', 'visa', 'master'];
    if (isAppMode(['T01'])) {
      paymentMethods.push('ae');
    }
    paymentMethods = [...paymentMethods, 'wechat_pay', 'alipay', 'unionpay', 'cheque'];
    if (isAppMode(['T17'])) {
      paymentMethods.push('credit');
    }
    const paymentMethodOptions = paymentMethods.map(key => {
      return { value: key, text: oI18n.t(`paymentMethod.${key}`) };
    });
    Vue.prototype.$paymentMethodOptions = paymentMethodOptions;

    let grades = ['P1', 'P2', 'P3', 'P4', 'P5', 'P6', 'S1', 'S2', 'S3', 'S4', 'S5', 'S6'];
    let gradeValueText = false;
    let excludeMenuList = ['requirement', 'student-requirement', 'online-course', 'notify', 'blog', 'student-blog', 'video', 'website-setting', 'setting-requirement', 'enquiry'];
    let setting = {
      startTime: '08:00',
      endTime: '23:00',
      interval: 15,
    };
    if (isAppMode(['DEV', 'UAT', 'T01', 'T03', 'T11', 'T25', 'T32', 'T37', 'T47', 'T49', 'T51', 'T53', 'T56', '61+'])) {
      setting.interval = 5;
    }
    if (isAppMode(['68+'])){
      excludeMenuList = ['online-course'];
    }
    try {
      const ImportStatic = await require(`@/static/${config.VUE_APP_RUN_MODE}`);
      if (ImportStatic.main !== undefined) {
        Vue.use(ImportStatic.main, { config });
      }
      if (ImportStatic.gradeList !== undefined) {
        grades = ImportStatic.gradeList;
      }
      if (ImportStatic.gradeValueText !== undefined) {
        gradeValueText = ImportStatic.gradeValueText;
      }
      if (ImportStatic.excludeMenuList !== undefined) {
        excludeMenuList = ImportStatic.excludeMenuList;
      }
      if (ImportStatic.settingStartTime !== undefined) {
        setting.startTime = ImportStatic.settingStartTime;
      }
      if (ImportStatic.settingEndTime !== undefined) {
        setting.endTime = ImportStatic.settingEndTime;
      }
      if (ImportStatic.settingInterval !== undefined) {
        setting.interval = ImportStatic.settingInterval;
      }
    } catch (err) {} finally {
      // **************** 年級
      Vue.prototype.$gradeOptions = grades.map(key => {
        if (gradeValueText) {
          return { value: key, text: key };
        } else {
          return { value: key, text: oI18n.t(`gradeOption.${key}`) };
        }
      });

      if (isAppMode(['DEV', 'UAT'])) {
        excludeMenuList = [];
      }
      Vue.prototype.$excludeMenuList = excludeMenuList;

      Vue.prototype.$settings = setting;
    }
    let calendarTimes = [];
    try {
      let start_hour = parseInt(setting.startTime.split(':')[0]);
      let start_minute = parseInt(setting.startTime.split(':')[1]);
      const end_hour = parseInt(setting.endTime.split(':')[0]);
      const end_minute = parseInt(setting.endTime.split(':')[1]);
      let generate_hour = start_hour;
      for (let hour = generate_hour; hour < end_hour; hour++) {
        calendarTimes.push({"start_time": `${hour.toString().padStart(2, '0')}:${start_minute.toString().padStart(2, '0')}`, 'end_time': `${(hour+1).toString().padStart(2, '0')}:${end_minute.toString().padStart(2, '0')}`});
      }

    } catch (err) {
    } finally {
    }
      Vue.prototype.$calendarTimes = calendarTimes;

    const routerObj = router.init(oI18n, excludeMenuList, config);
    new Vue({
      router: routerObj,
      store,
      vuetify,
      i18n: oI18n,
      render: h => h(App),
    }).$mount('#app')
  })
})